import { render, staticRenderFns } from "./SupplierInsight.vue?vue&type=template&id=3f861498&scoped=true&"
import script from "./SupplierInsight.vue?vue&type=script&lang=js&"
export * from "./SupplierInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f861498",
  null
  
)

export default component.exports